import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel, Modal } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import DataSelectTable from "../base/DataSelectTable";
import { translate } from '../base/Translation';

export default class ClientEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_client: "/client/save/:client",
			get_client: "/client/fetch/:client",
			get_brands: "/brand/fetch/all",
			get_client_users: "/user/fetch/by/role/:role/by/brand/:brand",
		});

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			showModal: false,
			client: null,
			brands: [],
			client_users: [],
			tableColumns: [
				{ name: "select", display: "#", sort: true, width: 5 },
				{ name: "name", display: translate("Meno"), sort: true, width: 20 },
				{ name: "surname", display: translate("Priezvisko"), sort: true, width: 20 },
				{ name: "email", display: translate("Email"), sort: true, width: 55 },
			]
		};
	}

	fetchData() {
		this.api.request({
			route: "get_client",
			params: { client: this.props.params.clientID },
			success: (response) => {
				this.setState({ client: response });
				this.fetchUsers();
			}
		});

		this.api.request({
			route: "get_brands",
			success: (response) => {
				this.setState({ brands: response });
			}
		});
	}

	fetchUsers(brand = false) {
		this.api.request({
			route: "get_client_users",
			params: { role: 3, brand: brand ? brand : this.state.client.brand.id },
			success: (response) => {
				this.setState({ client_users: response });
			}
		});
	}

	saveData() {
		this.api.request({
			route: "save_client",
			params: { client: this.props.params.clientID },
			data: this.state.client,
			created: (response) => {
				browserHistory.push("/clients");
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}


	/**
	 * Change events 
	 */

	onChange(evt) {
		// Get from state
		let data = this.state.client;

		if (evt.target.name !== "brand") {
			// Update it's value
			data[evt.target.name] = evt.target.value;
		} else {
			data[evt.target.name]["id"] = evt.target.value;
			data.users = [];
			this.fetchUsers(evt.target.value);
		}

		// Update in state
		this.setState({ client: data });
	}

	onTableSelect(index, selected) {
		let newClient = this.state.client;

		newClient.users = selected;

		this.setState({ client: newClient });
	}

	onSave(evt) {
		this.saveData();
	}

	handleClose() {
		this.setState({ showModal: false });
	}

	handleShow() {
		this.setState({ showModal: true });
	}
	
	/**
	*
	* Render methods
	*
	*/
	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (this.state.client === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			)
		}

		return (
			<Page>
				<PageHeader title={this.state.client.name} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Kód klienta")}</ControlLabel>
									<FormControl defaultValue={this.state.client.identifier} name="identifier" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Meno")}</ControlLabel>
									<FormControl defaultValue={this.state.client.name} name="name" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Značka")}</ControlLabel>
									<FormControl componentClass="select" name="brand" defaultValue={this.state.client.brand.id}
										onChange={this.onChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderOptions(this.state.brands)}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Adresa")}</ControlLabel>
									<FormControl defaultValue={this.state.client.address} name="address" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Obec")}</ControlLabel>
									<FormControl defaultValue={this.state.client.city} name="city" onChange={this.onChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header="Rozšírené">
								<FormGroup>
									<ControlLabel>{translate("IČO")}</ControlLabel>
									<FormControl defaultValue={this.state.client.business_id} name="business_id" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("IČ-DPH")}</ControlLabel>
									<FormControl defaultValue={this.state.client.vat_number} name="vat_number" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("DIČ")}</ControlLabel>
									<FormControl defaultValue={this.state.client.tax_id} name="tax_id" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("IBAN")}</ControlLabel>
									<FormControl defaultValue={this.state.client.iban} name="iban" onChange={this.onChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={6}>
						<Panel header={translate("Používatelia")}>
								<table className="table table-responsive table-hover table-striped" style={{ marginBottom: "1rem" }}>
									<thead>
										<tr>
											<th style={{ width: "33.3333%" }}>{translate("Meno")}</th>
											<th style={{ width: "33.3333%" }}>{translate("E-mail")}</th>
											<th style={{ width: "33.3333%", textAlign: "right" }}>{translate("Možnosti")}</th>
										</tr>
									</thead>
									<tbody>
										{this.state.client.users.length > 0 ? this.state.client.users.map(function (user, index) {

											user = this.state.client_users.find((u) => {
												return u.id === user.id;
											});

											if (!user) {
												return;
											}

											return (
												<tr key={"sub_" + user.email}>
													<td>
														{user.name + " " + user.surname}
													</td>
													<td>
														{user.email}
													</td>
													<td style={{ textAlign: "right" }}>
														<button className="btn btn-danger" onClick={(e) => {
															let client = this.state.client;

															const index = client.users.findIndex(function (u) {
																return u.id === this;
															}.bind(user.id));

															if (index > -1) {
																client.users.splice(index, 1);
															}

															this.setState({ client });

														}}><i className="fa fa-trash" /></button>
													</td>
												</tr>
											)
										}.bind(this)) : <tr><td colSpan={3}>{translate("Nie je čo zobraziť.")}</td></tr>}
									</tbody>
								</table>
								<Row>
									<Col md={12}>
										<button className="btn btn-success pull-right" onClick={this.handleShow.bind(this)}>{translate("Pridať")}</button>
									</Col>
								</Row>
								<Modal show={this.state.showModal} onHide={this.handleClose}>
									<Modal.Header closeButton>
										<Modal.Title>{translate("Výber používateľov")}</Modal.Title>
									</Modal.Header>
									<Modal.Body>
										<DataSelectTable
											tableColumns={this.state.tableColumns}
											data={this.state.client_users}
											selected={this.state.client.users}
											onChange={this.onTableSelect.bind(this)} />
									</Modal.Body>
									<Modal.Footer>
										<Button onClick={this.handleClose}>{translate("Zatvoriť")}</Button>
									</Modal.Footer>
								</Modal>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Notifikácia")}>
								{this.state.client.subscribers.map(function (sub, index) {
									return (
										<div className="row" key={"sub_" + sub.email}>
											<div className="col-md-3">
												<div className="form-group">
													<input type="text" defaultValue={sub.name} placeholder={translate("Názov")} className="form-control" />
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<input type="text" defaultValue={sub.email} placeholder={translate("E-Mail")} className="form-control" />
												</div>
											</div>
											<div className="col-md-3">
												<div className="form-group">
													<input type="text" defaultValue={sub.phone} placeholder={translate("Telefón")} className="form-control" />
												</div>
											</div>
											<div className="col-md-2">
												<div className="form-group">
													<button className="btn btn-danger" onClick={(e) => {
														let client = this.state.client;

														const index = client.subscribers.findIndex(function (s) {
															return s.email === this;
														}.bind(sub.email));

														if (index > -1) {
															client.subscribers.splice(index, 1);
														}

														this.setState({ client });

													}}><i className="fa fa-trash" /></button>
												</div>
											</div>
										</div>
									)
								}.bind(this))}
								<div className="row">
									<div className="col-md-3">
										<div className="form-group">
											<input type="text" defaultValue="" className="form-control" placeholder={translate("Názov")} ref={(input) => { this.sub_name = input }} />
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<input type="text" defaultValue="" className="form-control" placeholder={translate("E-Mail")} ref={(input) => { this.sub_email = input }} />
										</div>
									</div>
									<div className="col-md-3">
										<div className="form-group">
											<input type="text" defaultValue="" className="form-control" placeholder={translate("Telefón")} ref={(input) => { this.sub_phone = input }} />
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<button className="btn btn-success" onClick={(e) => {
												let client = this.state.client;

												client.subscribers.push({
													name: this.sub_name.value,
													email: this.sub_email.value,
													phone: this.sub_phone.value
												});

												this.sub_name.value = "";
												this.sub_email.value = "";
												this.sub_phone.value = "";

												this.setState({ client });

											}}>{translate("Pridať")}</button>
										</div>
									</div>
								</div>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/client/ClientEdit.js